<template>
	<div>
		<!-- 客户列表 -->
		
		<template v-if="isearch">
			<listheader @settable="setfntable" @uprenew="uprenew" @screen="fn_screen" ref="refader" 
				:one_selectlist="statelist":isimport="true" :two_selectlist="followstage" title="客户列表" 
				:localoperate="localviewOperate"
				:types="1" @exportclick="exportclick" @importclick="importclick" @createclick="createclick"
				:filter_items="filterpuplist" :sortlist="sortlist">
			</listheader>
		</template>
		
		
		<!--  -->
		<!-- 新建，编辑 -->
		<newbullet :title="billet_tit" :loading="!createPup" :isshow.sync="createPup" :classlist="classlist"
			:fieldlist="field_create" @saveer="fnCreateSave" @fnswitch="switchModule" :savenew="savenew"></newbullet>
		<!-- 列表 -->
		<div class="table_box style2" v-loading="table_loading" v-show="!table_loading">
			<!--  -->
			<!-- datapage check_list  -->
			<tabcontainer :ischecks="false" :list.sync="datapage.list" :total.sync="datapage.total"
				:pagesize.sync="datapage.pagesize" :page.sync="datapage.page" :surplus="surplus" @returow="showDetails"
				@retucheck="(e) => {check_list = e.val;}" @changesize="modify_pagesize" @changepage="switch_page">
				<!--  -->
				<template slot="body">
					<!--  -->
					<el-table-column align="center" type="selection" fixed width="50"></el-table-column>
					<!--  -->
					<el-table-column prop="customer_name" align="left" label="客户" fixed width="350">
						<template v-slot="scope">
							<div class="Flexalign">
								<template>
									<div style="width: 40px; height: 40px">
										<img :src="scope.row.head_image" alt="" v-if="scope.row.head_image">
										<img src="~assets/img/def_icon.png" v-else>
									</div>
								</template>
								<div style="display: inline-block; margin-left: 10px">
									<div>
										<div>
											<span
												style="color: #000; font-weight: bold">{{ scope.row.customer_name || "" }}</span>
											<span style="color: rgb(39, 165, 56); margin-left: 5px"
												v-if="scope.row.openid">
												@微信
											</span>
											<span style="color: #eda150; margin-left: 5px"
												v-else-if="scope.row.external_userid">
												@企微
											</span>
										</div>
										<div class="bot_txt" v-if="scope.row.new_record">
											近7天有
											<span class="color0">{{ scope.row.record_count }}</span>
											条动态，{{ scope.row.new_record.zhuangTai || "" }}查看了{{scope.row.new_record.leixin || ""}}
										</div>
										<div class="bot_txt" v-else>
											近7天有
											<span class="color0">{{ scope.row.record_count }}</span>
											条动态
											<template>
												，{{ scope.row.create_time ? scope.row.create_time.slice(0, 10): ""}}被{{ scope.row.member_name || "" }}添加了
											</template>
										</div>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<!--  -->
					<el-table-column prop="qy_name" align="center" label="企业名称">
						<template v-slot="scope">
							<span>
								{{ scope.row.qy_name }}
							</span>
						</template>
					</el-table-column>
					<!--  -->
					<el-table-column prop="member_name" align="left" label="负责人">
						
					</el-table-column>
					<!--  -->
					<el-table-column prop="follow_up_stage" align="center" label="跟进阶段">
						<template v-slot="scope">
							<span>
								{{ scope.row.follow_up_stage }}
							</span>
						</template>
					</el-table-column>
					<!--  -->

					<el-table-column prop="state" align="center" label="客户状态">
						<template v-slot="scope">
							<span v-if="scope.row.state === 0">未成交</span>
							<span v-if="scope.row.state === 1">已成交</span>
						</template>
					</el-table-column>
					<!--  -->
					<el-table-column prop="creator_name" align="center" label="创建人">
					</el-table-column>
					<!--  -->
					<el-table-column prop="create_time" align="center" label="添加时间">
						<template v-slot="scope">
							<span>
								{{ scope.row.create_time }}
							</span>
						</template>
					</el-table-column>
					<!--  -->
				</template>
				<!--  -->
				<!--  -->
				<template slot="tabtns">
					<el-button @click="custom_click(1)" class="color1"
						:disabled="check_list.length == 0">转让客户</el-button>
					<el-button @click="custom_click(2)" class="color1"
						:disabled="check_list.length == 0">添加协作人</el-button>
					<el-button @click="custom_click(3)" class="color1"
						:disabled="check_list.length == 0">退回公海</el-button>
				</template>
				<!--  -->
			</tabcontainer>
			<!--  -->
		</div>

		<!-- 详情划窗 -->
		<detailspup ref="refdetail" ptitle="客户信息" :types="1" :dinfo="currentDetail_info" :isshow.sync="drawer_show" :loading="drawer_loading"
			:stablelist="comtomerModuleTable" :classlist="classlist" :fieldlist="field_details" :memberlist="memberlist"
			:topselecto="statelist" :topselectt="followstage" :content_id="drawer_info.customer_id" @update="fn_update"
			@delesucc="fn_delesucc" @switchState="switchState" @btnClick="btnClick"></detailspup>


		<!-- 转让，添加协同人 弹出   -->
		<collaborator :show.sync="collab_show" :types="BatchType" :checklist="assistantChecklist"
			:dialogname="dialogname" @success="headaddxzr">
		</collaborator>
		<!--  -->
		<!-- 写跟进  -->
		<writefollow :show.sync="write_show" :customer_obj="customer_obj" :contact_obj="contact_obj" @addsuccess="addsuccess"></writefollow>
		<!--  -->
		
		<!-- 客户新建商机
		 content
		 select_field
		 -->
		<convertarea :types="1" :turndata="turndata" :isload.sync="turnisload"  @addsuccess="addBusinessess"
			:memberlist="memberlist"></convertarea>
		
	</div>
</template>

<script>
	var that;

	import {
		deepEqual,
		deepStrs,
		fn_retjson,
		retJSONArr,
		Basics_field,

		contrastDaily,
		headleTime,
		fn_findeditid,
		
		fn_Judgmentbtn,
	} from "network/defaults";


	import {


		kh_customer_list,
		timestampToTime,
		get_record,
		getCurrentfield,
		handlereq,
		alertMess,
		try_catch,
		fn_jurisd,
		retupower,
		retfieldPower,
		fn_fielddisabled,
		fnCustomPage,

		clickgate,
		getFollowUpList,
		getMumberUser,
		get_view,
		get_last_view,
		updata_view,
		add_view,
		del_view_id,
		view_sort,
		getCustLoglist,
	} from "network/kh_public";

	import {
		importCustomer,
		getCustomerInfoStoreConfig,
		importBatchCustomer,
		getfollow_up_list,
		releaseCustomers,
		distributeCustomer,
		addCustomerAssistantMember,
		//
		getCustomerDetails,
		editCustome2,
		lxrl_add_contact,
		lxrl_edit_contact,
		lxr_list2confield,
		lxrl_del_contact,
		lxrl_list_contact,
		get_module_comtomer,
		get_customer_form_id,
		get_customer_code,
		editCustomer,
	} from "network/hk_customer";

	import {
		get_membelist,
		addCustomerFollow,
		ToggleTime,
		handErrJson,
		fn_newfield,
		Basics_kehu,

		getCurrentWeek,
	} from "network/hk_operset";
	// 头部
	import listheader from "@/components/tabulation/listheader.vue";
	// 表格
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	// 新建、编辑字段
	import newbullet from "../components/newpup/newbullet.vue"
	// 详情推出
	import detailspup from "../components/newpup/detailspup.vue"
	// 添加协同人, 转让 弹出
	import collaborator from "../components/collaborator.vue";
	// 写跟进
	import writefollow from "@/components/integrated/writefollow.vue";
	// 客户新建商机 转换
	import convertarea from "../components/newpup/convertarea.vue"
	import {mix_built} from "@/mixins/builtClick.js"
	export default {
		mixins: [mix_built],
		components: {
			listheader,
			tabcontainer,
			newbullet,
			detailspup,
			collaborator,
			writefollow,
			convertarea,
		},
		props: {
			isearch:{
				type: Boolean,
				default: true,
			},
			searchname: {
				type: String,
				default: '',
			},
			searchshow: {
				type: Boolean,
				default: true,
			},
			Sreachmember: {
				type: Array,
				default: ()=>{
					return []
				},
			}, 
			Sreachsource: {
				type: Array,
				default: ()=>{
					return []
				},
			},
		},
		watch: {
			drawer_show() {
				if (!this.drawer_show) { // 详情划窗关闭
					this.clear_drawer()
				}
			},
			searchshow(){
				if(this.searchshow) {
					this.setSearchpage();
				}
			},
			
		},
		created() {
			if(this.isearch){
				this.getMumberList()
			}
			this.getFollList(1)
			this.surplus = this.$store.state.surplus
		},
		methods: { 
			
			setSearchpage(){
				let val = (this.searchname + '').trim()
				if(val) {
					this.search_name = val
					this.fn_tabledata();
				}
				this.memberlist = fn_retjson(this.Sreachmember)
				this.source_select = fn_retjson(this.Sreachsource)
			},
			
			exportclick() {
				exportExcel("#exportTab", "项目列表");
			},
			importclick() {},
			// 添加协同人，转让；返回 成员id 对象res
			headaddxzr(e) {
				if (e) {
					if (e.types == 1) {
						// 转让
						this.transferthe(e.member_id);
					} else if (e.types == 2) {
						// 添加协同人
						this.AddCollaborator(e.member_arr);
					}
				}
			},
			// 转让
			transferthe(member_id) {
				let customer_id = "";
				if (this.batch_edit) {
					let newArr = [];
					for (let item of this.check_list) {
						newArr.push(item.customer_id);
					}
					customer_id = newArr.join(",");
				} else {
					customer_id = this.currentpup_id;
				}
				this.distributeCuePool(customer_id, member_id);
			},
			// 转让客户 分配客户
			distributeCuePool(customer_id, member_id) {
				distributeCustomer(customer_id, member_id).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("操作成功", "success");
						// 关闭推出
						this.drawer_show = false;
						this.collab_show = false;
						this.batch_edit = false
						this.fn_tabledata();
					}
				});
			},
			//

			// 添加协作人
			AddCollaborator(member_arr) {
				let customer_id = "";
				if (this.batch_edit) {
					let newArr = [];
					for (let item of this.check_list) {
						newArr.push(item.customer_id);
					}
					customer_id = newArr.join(",");
				} else {
					customer_id = this.currentpup_id;
				}
				let member_id = "";
				if (member_arr.length) {
					member_id = member_arr.join(",") + ",";
				}
				this.addCustomer_Assistant(customer_id, member_id);
			},
			// 编辑客户协同人
			addCustomer_Assistant(customer_id, assistant_member_id) {
				addCustomerAssistantMember(customer_id, assistant_member_id).then((res) => {
					if (this.$handlereq(res)) {
						this.fn_tabledata();
						this.$alertMess("编辑成功", "success");
						// 关闭推出
						this.drawer_show = false;
						this.collab_show = false;
						this.batch_edit = false
					}
				});
			},
			// 批量按钮点击  公海客户 customer_id
			custom_click(index) {
				let list = this.check_list;
				if (list.length) {
					let newArr = [];
					for (let item of list) {
						newArr.push(item.customer_id);
					}
					this.batch_edit = true
					if (index == 1) {
						// 转让
						this.collab_show = true;
						this.BatchType = 1;
						this.dialogname = "转让客户";
					} else if (index == 2) {
						// 添加协作人
						this.collab_show = true;
						this.BatchType = 2;
						this.dialogname = "添加协作人";
					} else if (index == 3) {
						// 退回公海
						this.rehighseas(newArr.join(","));
					}
				}
			},
			// 详情推出按钮点击
			switchState(e) {
				let {
					flag
				} = e
				this.batch_edit = false
				this.assistantChecklist = [];
				if (flag == 2) { // 转让客户
					this.collab_show = true;
					this.BatchType = 1;
					this.dialogname = "转让客户";
					let member_id = this.drawer_info.member_id || '';
					this.assistantChecklist.push(member_id);
				} else if (flag == 3) { // 添加协同人
					this.collab_show = true;
					this.BatchType = 2;
					this.dialogname = "添加协作人";
					let assistant_Str = this.drawer_info.assistant_member_id || '';
					if (assistant_Str &&typeof assistant_Str == "string") {
						let arr = assistant_Str.split(",");
						for (let item of arr) {
							if (item) {
								let member_id = item * 1;
								this.assistantChecklist.push(member_id);
							}
						}
					}
				} else if (flag == 4) { // 退回公海
					this.rehighseas(this.currentpup_id)
				}
			},
			// 退回公海
			rehighseas(customer_id) {
				this.$confirm("您确定要退回公海吗?")
					.then(() => {
						releaseCustomers(customer_id).then((res) => {
							if (this.$handlereq(res)) {
								this.$alertMess("退回成功");
								this.fn_tabledata();
								this.drawer_show = false;
							}
						});
					})
					.catch(() => {});
			},
			// ========================================================
			// 切换模板
			switchModule(e) {
				this.field_create = []
				this.field_initial = [];

				this.isSwitch = true
				let formId = e;
				// 模板id
				this.currentMod_id = formId;
				this.getmodulelist(this.c_projcet_div_id)
			},
			// 保存数据处理
			fn_Savedatas(flag, info) {
				// flag  1.联系人； 2.客户；
				let fd = new FormData();
				let currobj = this.savelist;
				let Basicslist = []
				if (flag == 1) { // 联系人
					Basicslist = currobj.filter(v => v.type == 0)

					this.fn_circulatedata(fd, this.Referencelxr, flag)
					// 关联类型
					fd.append("relation_type", 2);
					// 协同人
					let assistant = this.findfont("协同人", 1);
					if (assistant.length) { // 	否	string	协同人id	逗号间隔 加 逗号
						fd.append("assistant_member_id", assistant.join(",") + ",");
					}
					// 联系人模板
					if (this.contact_projcetId) {
						fd.append("form_id", this.contact_projcetId);
					}
					let info_newArr1 = Basics_field(Basicslist);
					fd.append("contact_info", JSON.stringify(info_newArr1));
				} else if (flag == 2) { // 客户
					Basicslist = currobj.filter(v => v.type != 0)
					let info_newArr2 = Basics_field(Basicslist);
					this.fn_circulatedata(fd, this.ReferenceKehu, flag)
					fd.append("is_lock", 0); // 不为公海
					fd.append("customer_info", JSON.stringify(info_newArr2));
					if (info && info.id) {
						fd.append("contact_id", info.id); // 关联的主联系人id
					}
				}
				return fd;
			},
			// 设置post值
			fn_circulatedata(fd, cArr, flag) {
				for (let i = 0; i < cArr.length; i++) {
					let {
						name,
						key
					} = cArr[i]
					let res_ = this.findfont(name, flag)
					if (res_) {
						fd.append(key, res_);
					}
				}
			},
			// 查询字段内容
			findfont(field, flag) {
				let currArr = []
				if (flag == 1) { // 联系人字段
					currArr = this.savelist.filter(v => v.type == 0)
				} else if (flag == 2) { // 客户字段
					currArr = this.savelist.filter(v => v.type != 0)
				}
				if (currArr.length) {
					let index = currArr.findIndex((v) => v.field_sign == field || v.field == field);
					if (index != -1) {
						return currArr[index].content;
					} else {
						return "";
					}
				}
			},
			// 新建保存
			fnCreateSave(e) {
				if (e && e.fieldlist) {
					let {
						flag,
						fieldlist
					} = e
					// 先新建联系人再 建客户
					this.savelist = retJSONArr(fieldlist) || [];
					this.createlxr(flag)
				}
			},
			// 新建， 修改联系人 13553310800
			createlxr(flag) {
				let resdata = this.fn_Savedatas(1)
				if (this.edit_show) {
					resdata.append('customer_id', this.currentpup_id); // 客户id
					resdata.append("contact_id", this.currentContact.contact_id); // 联系人id

					// 操作日志
					let oldDaily = this.contactsDaily;
					let rastobj = this.savelist.filter(v => v.type == 0)
					let edit_data = contrastDaily(oldDaily, rastobj, 1);
					if (edit_data) {
						resdata.append('edit_data', edit_data);
					}
					lxrl_edit_contact(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.creatse_kehu(); // 之后修改客户信息
						}
					});
				} else {
					// 新建
					resdata.append("customer_id", 9999999);
					lxrl_add_contact(resdata).then((res) => {
						// 新建联系人之后 获得联系人id 再给新建客户
						if (this.$handlereq(res)) {
							if (res.result) {
								let id = res.result * 1;
								this.creatse_kehu(id, flag);
							}
						}
					});
				}
			},

			// 新建,编辑客户
			creatse_kehu(id, flag) {

				if (this.edit_show) {
					let resdata = this.fn_Savedatas(2)
					resdata.append('customer_id', this.currentpup_id); // 客户id
					resdata.append("contact_id", this.currentContact.contact_id); // 联系人id

					// 操作日志
					let oldDaily = this.dailyRecord;
					let rastobj = this.savelist.filter(v => v.type != 0)
					let edit_data = contrastDaily(oldDaily, rastobj, 1);
					if (edit_data) {
						resdata.append('edit_data', edit_data);
					}
					editCustome2(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("编辑成功", "success");
							this.field_create = [];
							this.drawer_show = false;
							this.createPup = false;
							this.fn_tabledata();
						}
					});
				} else {
					// 新建
					let info = { //联系人id
						id,
					}
					let resdata = this.fn_Savedatas(2, info)
					importCustomer(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("添加成功", "success");
							this.field_create = [];
							if (flag) { // 新建并保存
								this.createclick();
							} else { // 保存
								this.createPup = false;
								this.clear_drawer()
							}
							this.fn_tabledata();
						}
					});
				}

			},

			clear_drawer() {
				this.dailyRecord = [] // 编辑前的字段 ，用于判断是否修改过
				this.contactsDaily = []
				this.drawer_info = '' // 详情所有信息
				this.currentDetail_info = '' // 用于弹窗的字段
				this.editfieldlist = [] // 用于编辑的字段
				this.currentpup_id = '' // 当前详情id
				this.isTableShow = false
				this.comtomerModuleTable = []
				this.field_details = []
				this.savenew = true
				this.edit_show = false
				this.currentMod_id = ''

				this.currentContact = ''
				this.isSwitch = false

				this.assistantChecklist = [];
				
				this.turnisload = false
			},
			fn_delesucc() {
				this.drawer_show = false
				this.fn_tabledata();
			},
			// 编辑点击
			fn_editdatas() {
				this.edit_show = true
				this.savenew = false
				this.isSwitch = false
				this.billet_tit = '编辑客户'
				if (this.field_create.length) {
					this.createPup = true
				} else {
					this.getmodulelist(this.c_projcet_div_id)
				}
			},
			btnClick(e) {
				let {
					flag
				} = e
				if(flag == 1){  // 新建跟进
					this.write_show = true
					this.customer_obj = {
						id: this.drawer_info.customer_id || "",
						name: this.drawer_info.customer_name || "",
					}
				}
				else if (flag == 3) { // 编辑 
					this.fn_editdatas()
				}
				else if (flag == 7) { // 新建商机
					this.turnisload = true
				}
			},
			// 新建商机成功
			addBusinessess(){
				if(this.$refs.refdetail) {
					this.$refs.refdetail.RefreshAssocia()
				}
			},
			// 添加跟进成功
			addsuccess() {
				this.fn_update()
				this.write_show = false;
			},
			//

			// 新建点击
			createclick() {
				this.billet_tit = '新建客户'
				this.edit_show = false
				this.savenew = true
				this.isSwitch = false
				this.field_create = []
				this.fn_getVal_Code()
			},
			// 获取编号 
			fn_getVal_Code(nflag) {
				get_customer_code().then((res) => {
					if (!this.$handlereq(res)) return
					let resobj = res.result ? res.result.cust_code : '';
					this.valCode = resobj
					this.getmodulelist(this.c_projcet_div_id)
				})
			},
			// 获取所有字段模板 1 级模板
			getmodulelist(projcet_div_id) {
				get_module_comtomer(projcet_div_id).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result || []
					if (obj.length) {
						for (let item of obj) {
							item.id = item.form_id
						}
					};
					// 新建默认选择系统模板 使用 form_id 2级模板
					let form_id = obj[0].form_id || '';
					if (projcet_div_id == 1) { // 客户
						// 模板列表
						this.currentModulList = fn_retjson(obj)
						// 2级模板id 
						if (!this.currentMod_id) {
							this.currentMod_id = form_id
						} else {
							let id_flag = obj.some(v => v.form_id == this.currentMod_id)
							if (!id_flag) { // 未找到该模板
								this.currentMod_id = form_id;
							}
						}
					
						if (this.field_initial.length) {
							let obj = fn_retjson(this.field_initial)
							// 赋值改动字段
							this.handle_createField(obj)
							// 获取表头展示
							if (this.isTableShow) {
								this.field_details = fn_retjson(obj)
								this.drawer_show = obj.length ? true : false;
								this.drawer_loading = !this.drawer_show;
							} else {
								// 创建弹窗 是否弹出
								this.createPup = obj.length ? true : false;
								this.clear_drawer()
							}
					
							this.field_create = obj
							if (!this.isSwitch) { // 不是切换模板 状态
								this.getmodulelist(6) // 获取联系人模板字段
							} else { // 不需要再获取联系人字段
								this.field_create = this.field_create.concat(this.lxrfieldlist)
							}
						} else { // 获取客户字段列表
							this.getmoduleField(projcet_div_id, this.currentMod_id)
						}
					
					} else if (projcet_div_id == 6) { // 联系人
						// 模板列表
						this.contact_modules = fn_retjson(obj)
						// 2级模板id
						this.contact_projcetId = form_id
						this.getmoduleField(projcet_div_id, form_id)
					}
				});

			},
			// 获取当前选用模板下的所有字段信息  获取2级模板
			getmoduleField(projcet_div_id, form_id) {
				get_customer_form_id(form_id, 1, projcet_div_id).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result || [];
					if (projcet_div_id == 1) { // 客户
						// 最初始字段，未改动
						this.field_initial = fn_retjson(obj)
						// 赋值改动字段
						this.handle_createField(obj)
						// 获取表头展示
						if (this.isTableShow) {
							this.field_details = fn_retjson(obj)
							this.drawer_show = obj.length ? true : false;
							this.drawer_loading = !this.drawer_show;
						} else {
							// 创建弹窗 是否弹出
							this.createPup = obj.length ? true : false;
							this.clear_drawer()
						}
						this.field_create = obj
						if (!this.isSwitch) { // 不是切换模板 状态
							this.getmodulelist(6) // 获取联系人模板字段
						} else { // 不需要再获取联系人字段
							this.field_create = this.field_create.concat(this.lxrfieldlist)
						}
					} else if (projcet_div_id == 6) { // 联系人
						this.handle_lxr(obj)
						this.lxrfieldlist = fn_retjson(obj)
					}
				})
			},

			// 处理新建字段
			handle_createField(data) {
				
				for (let item of data) {
					fn_newfield(item, false)
					item.is_show = true // 字段显示
					item.disabled = false // 字段禁用
					// required: 1 必填
					// 详情信息 || item.config_id
					if (this.editfieldlist.length) {
						let curid = item.field_id || item.id || item.config_id;
						let res1 = fn_findeditid(curid, this.editfieldlist, this.field_initial)
						if (res1) {
							item.content = res1.content
							item.select_field = res1.select_field
						}
					}
					// 
					let field = item.field_sign || item.field;
					if (item.field == "客户名称") {
						item.maxLength = 50;
						if (this.drawer_info) {
							item.select_field = item.content = this.drawer_info.customer_name
						}
					} else if (item.field == "电话") {
						item.maxLength = 30;
						if (this.drawer_info) {
							item.select_field = item.content = this.drawer_info.phone
						}
					} 
					else if (item.field == "企业名称") {
						item.maxLength = 30;
						if (this.drawer_info) {
							item.select_field = item.content = this.drawer_info.qy_name
						}
					}
					else if (item.field == "客户来源") {
						item.field_list = this.source_select;
						if (this.drawer_info) {
							item.select_field = this.drawer_info.source_name
							item.content = this.drawer_info.source * 1
						} else {
							item.content = this.source_select[0] ? this.source_select[0].id : "";
						}
					} else if (item.field == this.templaName) {
						item.field_list = this.currentModulList;
						item.content = this.currentMod_id;
						item.field_type = 18
						if (this.drawer_info) {
							let cindex = this.currentModulList.findIndex(v => v.id == this.currentMod_id)
							if (cindex != -1) {
								item.select_field = this.currentModulList[cindex].name
							}
						}
					} else if (item.field == "客户编号") {
						if (this.drawer_info) {
							if (this.editfieldlist.length) {
								let findex = this.editfieldlist.findIndex(v => v.field_sign == '客户编号' || v.field == '客户编号')
								if (findex != -1 && this.editfieldlist[findex]) {
									item.select_field = item.content = this.editfieldlist[findex].content
								}
							}
						} else {
							item.content = this.valCode;
						}
					}

					// 表头展示  不为编辑切换模板
					if (item.is_table == 1 && !this.edit_show) {
						let ele = {
							character: item.character ? true : false,
							field: field,
							select_field: item.select_field,
							field_type: item.field_type,
							table_sort: item.table_sort,
						}
						this.comtomerModuleTable.push(ele)
						
					}
				}

				this.dailyRecord = JSON.parse(JSON.stringify(data))
			},
			//  contact_modules contact_projcetId
			handle_lxr(data) {
				for (let item of data) {
					fn_newfield(item, false)
					// 字段显示
					item.is_show = true
					// 字段禁用
					item.disabled = false
					// required: 1 必填
					// 详情信息 
					if (this.currentContact && this.currentContact.contact_info) {
						let contactInfoList = retJSONArr(this.currentContact.contact_info)
						let curid = item.field_id || item.id;
						let res1 = fn_findeditid(curid, contactInfoList, data)
						if (res1) {
							item.content = res1.content
							item.select_field = res1.select_field
						}
					}

					let field_sign = item.field_sign || item.field;
					let filerlist = [
						'邮箱', '微信号', 'QQ号', '职务',
					]
					let flagfiler = filerlist.some(v => v == field_sign)
					if (flagfiler) {
						item.field_type = 1
						item.maxLength = 120
					}
					if (field_sign == '联系人姓名') {
						item.field_type = 1
						item.maxLength = 50
						if (this.currentContact) {
							item.select_field = item.content = this.currentContact.name
						}
					} else if (field_sign == '联系人模板') {
						item.is_show = false
						item.content = this.contact_projcetId
					} else if (field_sign == '联系人来源') {
						item.field_type = 5
						item.field_list = this.source_select
						if (!item.content) {
							if (this.source_select[0]) {
								item.select_field = this.source_select[0].name
								item.content = this.source_select[0].id
							}
						} else {
							let index1 = this.source_select.findIndex(v => v.id == item.content)
							if (index1 != -1) {
								item.select_field = this.source_select[index1].name || ''
							}
						}
					} else if (field_sign == '手机') {
						item.field_type = 1
						item.maxLength = 30
						if (this.currentContact) {
							item.select_field = item.content = this.currentContact.phone
						}
					} else if (field_sign == '生日') {
						item.field_type = 3
						if (item.content && typeof(item.content) == 'number') {
							item.select_field = item.content = timestampToTime(item.content, true)
						} else {
							item.select_field = item.content = ''
						}
					} else if (field_sign == '性别') {
						item.field_type = 5
						let list = [{
								id: 1,
								name: '男'
							},
							{
								id: 2,
								name: '女'
							},
							{
								id: 3,
								name: '未知'
							},
						]
						item.field_list = list
						if (!item.content) {
							item.select_field = '男'
							item.content = 1
						} else {
							let index1 = list.findIndex(v => v.id == item.content)
							if (index1 != -1) {
								item.select_field = list[index1].name || ''
							}
						}
					} else if (field_sign == '协同人') {
						item.field_type = 11
						item.content = []
					}
					item.type = 0

					this.field_create.push(item)
				}
				this.contactsDaily = JSON.parse(JSON.stringify(data))

			},
			// 
			// ========================================================





			//
			clearfilter() {
				this.search_member = []
				this.assistantMember = []
				this.searchPhone = ''
				this.source_id = []
				this.search_time = ''
				this.search_edit_time = ''
			},
			// 筛选条件列表更新 filterpuplist
			setfntable(e) {
				this.clearfilter()
				if (e && e.list) {
					let reslist = retJSONArr(e.list)
					this.setcustomfil(reslist)
					this.FilterList = fn_retjson(reslist) // 筛选条件列表
				}
				this.fn_tabledata();
			},
			setcustomfil(reslist){
				for (let item of reslist) {
					let {
						lv1_selVal,
						lv2_selVal,
						lv3_selVal
					} = item
					if (lv1_selVal == 0) {} // 创建人
					if (lv1_selVal == 1) { // 负责人
						this.search_member = lv3_selVal || []
					}
					if (lv1_selVal == 2) { // 协同人
						this.assistantMember = lv3_selVal || []
					}
					if (lv1_selVal == 3) { // 手机号
						this.searchPhone = lv3_selVal || ''
					}
					if (lv1_selVal == 4) { // 来源
						this.source_id = lv3_selVal || []
					}
					if (lv1_selVal == 5) { // 添加时间
						let restime = headleTime(lv3_selVal, lv2_selVal)
						this.search_time = restime
					}
					if (lv1_selVal == 6) { // 更新时间
						let restime = headleTime(lv3_selVal, lv2_selVal)
						this.search_edit_time = restime
					}
				}
			},
			// 下拉筛选改变
			fn_screen(e) {
				if (e) {
					// 固定筛选值
					this.search_name = e.search_name || ''
					this.sort_type = e.sort_type || 1
					// 不确定筛选值
					this.screVal1 = e.kh_state || []
					this.screVal2 = e.follow_id || []
					this.fn_tabledata();
				}
			},
			// 视图选择更新
			uprenew(e) {
				if (e && e.view_operate) {
					// 视图配置
					this.remoteviewOperate = retJSONArr(e.view_operate)
					this.clearSrceen()
					this.executeViewOperate();
				}
			},
			clearSrceen() {
				this.screVal1 = [];
				this.screVal2 = [];
				this.searchPhone = "";
				this.source_id = [];
				this.search_time = '';
				this.search_edit_time = '';
				this.search_name = "";
				this.search_member = [];
				this.assistantMember = [];
				this.sort_type = 1
			},
			// 执行视图配置   this.List  筛选条件
			executeViewOperate() {
				// 全部清空筛选
				if (this.remoteviewOperate.operate != 100) { // 系统视图
					if (this.$refs.refader) {
						this.$refs.refader.clearScreen()
					}
					this.class_type = this.remoteviewOperate.operate - 1;
					this.FilterList = fn_retjson(this.defFilter)
					this.fn_tabledata();
				} else { // 用户创建视图
					if (this.remoteviewOperate.class_type === undefined) {
						if (this.$refs.refader) {
							this.$refs.refader.clearScreen()
							this.FilterList = fn_retjson(this.defFilter)
						}
						this.class_type = 0;
						this.fn_tabledata();
					} else {
						let obj = fn_retjson(this.remoteviewOperate)
						this.class_type = fn_retjson(obj.class_type) // 资源类型
						this.screVal1 = fn_retjson(obj.kh_state) // 状态
						this.screVal2 = fn_retjson(obj.follow_id) // 阶段

						this.search_name = fn_retjson(obj.search_name) // 搜索名称
						this.FilterList = fn_retjson(obj.List) // 筛选条件列表
						this.sort_type = fn_retjson(obj.sort_type) // 排序
						this.search_member = fn_retjson(obj.search_member) // 负责人
						
						if(obj.List) {
							this.setcustomfil(obj.List)
						}
						

						this.source_id = fn_retjson(obj.source_id) // 来源
						let flag_ = deepStrs(this.defFilter, this.FilterList)
						// 当前筛选列表不等于默认列表
						if (!flag_) {
							this.fn_tabledata();
						}
					}
				}

			},
			// 获取当前本地视图配置
			fn_localView() {
				this.localviewOperate = {
					operate: 100,
					class_type: this.class_type || 0,
					kh_state: this.screVal1,
					follow_id: this.screVal2,
					search_name: this.search_name,
					List: this.FilterList,
					sort_type: this.sort_type,
					search_member: this.search_member,
				};
			},
			// 执行搜索
			fn_tabledata() {
				if (this.table_loading) return
				this.table_loading = true;
				this.fn_localView();
				// 判断是否为新视图，或者视图是否有修改 
				this.JudgmentOpen();

				let data = {
					sort_type: this.sort_type, //  否	string	排序类型 1:最新释放2:最新创建3:最新访问4:最新跟进
					pagesize: this.datapage.pagesize, //  	是	int	每页数量
					page: this.datapage.page,
					class_type: this.class_type || 0, // 资源类型  1:我负责的2:我协同的3:下属负责
				};
				let search_pval = (this.searchPhone + '').trim()
				if (search_pval) { // 手机搜索
					this.search_name = ''
					data.search_type = 2; //  否	int	搜索类型 //1:名称2:手机号
					data.search_name = this.searchPhone.trim();
				} else {
					let search_val = (this.search_name + '').trim()
					if (search_val) { // 名称搜索
						data.search_type = 1
						data.search_name = search_val;
					}
				}

				if (this.screVal1.length) { // 状态
					data.state = this.screVal1.join(",")
				}
				if (this.screVal2.length) { // 阶段
					data.follow_id = this.screVal2.join(",")
				}
				if (this.source_id.length) { // 来源
					data.source = this.source_id.join(",");
				}
				if (this.search_time) {
					data.search_time = this.search_time
				}
				if (this.search_edit_time) {
					data.edit_time = this.search_edit_time
				}
				if (this.search_member.length) {
					data.member_id = this.search_member.join(",");
				}
				if (this.assistantMember.length) {
					data.assistant_member_id = this.assistantMember.join(",");
				}
				kh_customer_list(data).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result.data;
					this.handle_data(obj);
					let total = res.result.total;
					this.datapage.total = total
					this.table_loading = false;
					if(this.searchshow) {
						this.$emit('echototal', {total}) 
					}
				});
			},

			// 处理数据
			handle_data(data) {
				if (data) {
					for (let item of data) {
						try {
							if (!item.qy_name) {
								let objs = retJSONArr(item.customer_info)
								if (objs && objs.length) {
									let index = objs.findIndex((v) => v.field == "企业名称");
									if (index != -1) {
										item.qy_name = objs[index].content || "";
									}
								}
							}
						} catch (err) {
							this.$alertMess(err.message, "error");
						}
						get_record(item.new_record);
					}
					this.datapage.list = data;
				}
			},

			setsaveBtn(flag) {
				if (this.$refs.refader) {
					this.$refs.refader.setSaveBtn(flag)
				}
			},
			setnewBtn(flag) {
				if (this.$refs.refader) {
					this.$refs.refader.setNewBtn(flag)
				}
			},
			//判断视图按钮是否打开 
			JudgmentOpen() {
				let cobj = fnCustomPage("customer");
				let findobj = {
					localviewOperate: this.localviewOperate,
					remoteviewOperate: this.remoteviewOperate,
					defFilter: this.defFilter,
					FilterList: this.FilterList,
					screVal1: this.screVal1,
					screVal2: this.screVal2,
					search_name: this.search_name,
					sort_type: this.sort_type,
					def_sort: cobj.sort,
				}
				let resobj = fn_Judgmentbtn(findobj)
				let {customflag, systemflag} = resobj
				if(customflag) { // 用户创建的视图
					this.setsaveBtn(customflag) 
				}
				else {  // 系统视图
					this.setnewBtn(systemflag) 
				}
			},
			// 侧边弹窗联系人列表获取
			getcontacs() {
				let data = {
					pagesize: 999,
					sort_type: 1,
					class_type: 0,
					customer_id: this.currentpup_id,
				};
				// 获取 列表
				lxrl_list_contact(data).then((res) => {
					if (this.$handlereq(res)) {
						this.currentContact = ''
						let obj = res.result.data || [];
						if (!obj.length) return
						
						let arr = obj.filter((v) => v.is_main == 1);
						if (!arr.length) return
						this.contact_obj = {
							id: arr[0].contact_id,
							name: arr[0].name,
						}
						// customer_obj
						this.currentContact = arr[0];
						let contact_info = arr[0].contact_info;
						if (contact_info && typeof contact_info == "string") {
							let fieldarr = JSON.parse(contact_info) || [];
							let findex1 = fieldarr.findIndex(v => v.field_sign == '联系人模板')
							if (findex1 != -1 && fieldarr[findex1]) {
								this.contact_projcetId = fieldarr[findex1].content * 1;
								
							}
						}
					}
				});
			},
			showDetails(e) {
				let {
					row
				} = e;
				if (row.customer_id) {
					// 当前点击的id
					this.currentpup_id = row.customer_id;
					// 获取详情
					this.fn_getDelait(row.customer_id);
					// 获取该客户下的主联系人信息
					this.getcontacs();
				}
			},
			
			// 划窗刷新
			fn_update() {
				this.field_details = []
				this.comtomerModuleTable = []
				this.fn_getDelait();
			},
			// 获取详情 组件: detailspup
			fn_getDelait() {
				this.turndata = [] // 转合同所需数据
				this.drawer_loading = true;
				getCustomerDetails(this.currentpup_id).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result || '';
						if (!obj) return;
						// 用于弹窗的字段
						this.currentDetail_info = JSON.stringify(obj)
						// 字段信息
						let parse_info = retJSONArr(obj.customer_info)
						// 用于编辑的字段
						this.editfieldlist = fn_retjson(parse_info) || [];
						// 字段模板id
						if (obj.form_id) {
							this.currentMod_id = obj.form_id
						} else {
							if (parse_info) {
								let findex1 = parse_info.findIndex(v => v.field_sign == this.templaName || v.field == this.templaName)
								if (findex1 != -1 && parse_info[findex1]) {
									this.currentMod_id = parse_info[findex1].content * 1;
								}
							}
						}
						// 详情所有信息
						this.drawer_info = obj;
						this.isTableShow = true
						this.field_initial = []
						this.lxrfieldlist = []
						this.getmodulelist(this.c_projcet_div_id)
						
						this.setTrunVal(obj)
						
					}
				});
			},
			setTrunVal(obj){
				let ele1 = {
					field_sign: '客户',
					content: obj.customer_id || '',
					select_field: obj.customer_name || '',
				}
				let ele2 = {
					field_sign: '负责人',
					content: obj.member_id || '',
					select_field: obj.member_name || '',
				}
				this.turndata.push(ele1)
				this.turndata.push(ele2)
			},
			//
			modify_pagesize(e) {
				let {
					val
				} = e;
				this.datapage.page = 1;
				this.datapage.pagesize = val;
				this.fn_tabledata();
			},
			switch_page(e) {
				let {
					val
				} = e;
				this.datapage.page = val;
				this.fn_tabledata();
			},
			// -----------------------------------

			//获取跟进阶段
			getFollList(flag) {
				getFollowUpList(flag).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data;
						if (obj && obj.length) {
							for (let item of obj) {
								item.checked = false;
							}
						}
						this.followstage = obj;
					}
				});
			},
			//获取成员列表
			getMumberList() {
				if(this.memberlist.length) return
				getMumberUser().then((res) => {
					if (res.code == 1000) {
						let obj = res.result || [];
						for (let item of obj) {
							item.id = item.member_id
						}
						this.memberlist = obj
						this.fn_follow_up_list()
					}
				});
			},
			// 获取客户来源
			fn_follow_up_list() {
				if(this.source_select.length) return
				getfollow_up_list().then((res) => {
					if (this.$handlereq(res)) {
						this.source_select = res.result.data;
						this.setfilterArea()
					}
				});
			},
			setfilterArea() {
				this.filterpuplist = [

					{
						name: "创建人",
						list: this.memberlist,
						select: true,
						type: [{
							id: 0,
							name: "包含",
						}, ],
					},
					{
						name: "负责人",
						list: this.memberlist,
						select: true,
						type: [{
							id: 0,
							name: "包含",
						}, ],
					},
					{
						name: "协同人",
						list: this.memberlist,
						select: true,
						type: [{
							id: 0,
							name: "包含",
						}, ],
					},
					{
						name: "手机号",
						isinput: true,
						list: "",
						type: [{
							id: 1,
							name: "包含",
						}, ],
					},
					{
						name: "来源",
						select: true,
						list: this.source_select,
						type: [{
							id: 0,
							name: "包含",
						}, ],
					},
					{
						name: "添加时间",
						isTime: true,
						list: "",
						type: [{
								id: 2,
								name: "等于",
							},
							{
								id: 3,
								name: "介于",
							},
						],
					},
					{
						name: "更新时间",
						isTime: true,
						list: "",
						type: [{
								id: 2,
								name: "等于",
							},
							{
								id: 3,
								name: "介于",
							},
						],
					},

				]
				for (let item of this.filterpuplist) {
					item.disabled = false
				}

			},
		},
		data() {
			return {
				turndata: [],  // 转商机信息
				turnisload: false, // 客户添加商机是否打开
				surplus: 600,
				
				batch_edit: true,
				assistantChecklist: [],
				write_show: false,
				customer_obj: {
					id: "",
					name: "",
				},
				contact_obj: {
					id: "",
					name: "",
				},

				// 操作类型 ：1，单选； 2 多选
				BatchType: 1,
				// 添加协同人是否弹出
				collab_show: false,
				// 弹窗标题
				dialogname: "",

				c_projcet_div_id: 1,
				screVal1: [],
				screVal2: [],
				billet_tit: '新建项目',
				templaName: '客户模板',
				currentContact: '',
				statelist: [{
						name: '未成交',
						id: 0,
					},
					{
						name: '已成交',
						id: 1,
					},
				],
				// ================


				edit_show: false, // 是否为编辑状态

				field_initial: [], // 客户 未处理过的字段信息
				currentMod_id: '', // 客户 模板列表
				currentModulList: [], // 客户 当前模板 id

				lxrfieldlist: [], // 联系人 已处理过的字段信息
				contact_modules: [], // 联系人 模板列表
				contact_projcetId: '', // 联系人 当前模板 id


				field_create: [], // 未保存的 字段合集
				savelist: [], // 保存时的 字段合集
				dailyRecord: [], // 客户 编辑前的字段 ，用于判断是否修改过
				contactsDaily: [], // 联系人 编辑前的字段。 用于判断是否修改过

				drawer_info: '', // 详情所有信息
				currentDetail_info: '', // 用于弹窗的字段
				editfieldlist: [], // 用于编辑的字段

				currentpup_id: '', // 当前详情id
				isTableShow: false,
				comtomerModuleTable: [],
				field_details: [],
				savenew: true,
				drawer_show: false, // 详情划窗是否显示
				drawer_loading: true, // 详情划窗是否加载完成

				Referencelxr: [{
						key: 'name',
						name: '联系人姓名',
					},
					{
						key: 'phone',
						name: '手机',
					},
					{
						key: 'source',
						name: '联系人来源',
					},
					{
						key: 'email',
						name: '邮箱',
					},
					{
						key: 'job',
						name: '职务',
					},
					{
						key: 'qq',
						name: 'QQ号',
					},
					{
						key: 'wx',
						name: '微信号',
					},
					{
						key: 'gender',
						name: '性别',
					},
					{
						key: 'form_id',
						name: '联系人模板',
					},
				],

				ReferenceKehu: [{
						key: 'name',
						name: '客户名称',
					},
					{
						key: 'phone',
						name: '电话',
					},
					{
						key: 'customer_type',
						name: '客户类型',
					},
					{
						key: 'industry',
						name: '企业行业',
					},
					{
						key: 'source',
						name: '客户来源',
					},
					{
						key: 'email',
						name: '邮箱',
					},
					{
						key: 'qy_name',
						name: '企业名称',
					},
					{
						key: 'form_id',
						name: '客户模板',
					},
					{
						key: 'cust_code',
						name: '客户编号',
					},
				],

				// 客户 1级大分类
				classlist: [{
						name: "基础信息",
						type: 1,
					},
					{
						name: "联系信息",
						type: 2,
					},
					{
						name: "企业信息",
						type: 4,
					},
					{
						name: "身份信息",
						type: 3,
					},
					{
						name: "创建联系人",
						type: 0,
					},
				],
				// 新建弹窗
				createPup: false,
				// 是否为切换模板状态
				isSwitch: false,
				// 客户 编码
				valCode: '',



				// ================

				source_select: [],
				memberlist: [],
				followstage: [],
				
				statelist: [
					{
						name: '已成交',
						id: 1,
					},
					{
						name: '未成交',
						id: 0,
					},
				],

				table_loading: false,
				// 
				search_member: [], // 创建人，负责人
				assistantMember: [], // 协同人
				searchPhone: '', // 手机
				source_id: '', // 来源
				search_time: [], // 添加时间
				search_edit_time: [], // 更新时间
				// 
				class_type: 0, //	是	int	0:全部1:我负责的2:我协同的3:下属负责
				kh_state: [],
				source_id: [],
				search_name: '',
				sort_type: 1,
				follow_id: [],
				search_member: [],
				// 筛选条件弹窗列表
				FilterList: [{
					lv1_selVal: null,
					lv2_selVal: null,
					lv3_selVal: null,
				}, ],
				defFilter: [{
					lv1_selVal: null,
					lv2_selVal: null,
					lv3_selVal: null,
				}, ],
				// 筛选项
				filterpuplist: [],

				// 当前视图配置
				localviewOperate: {},
				// 执行视图配置
				remoteviewOperate: {},


				// 
				// 列表
				datapage: {
					pagesize: 50,
					page: 1,
					total: 0,
					list: [],
				},
				check_list: [],
				customPageSize: 50,
				// 排序列表
				sortlist: [
					{
						id: 1,
						name: '按最新创建排序',
					},
					{
						id: 2,
						name: '按最早创建排序',
					},
					{
						id: 3,
						name: '按最近访问排序',
					},
					{
						id: 4,
						name: '按最新跟进排序',
					},
				],
		
			}
		},
	}
</script>


<style lang="scss" scoped>
	@import "@/assets/css/public.scss";
	// .table_box{
	// 	border:solid 1px red;
	// }
</style>